import { render, staticRenderFns } from "./ShippingLabelModal.vue?vue&type=template&id=f2127b50&scoped=true"
import script from "./ShippingLabelModal.vue?vue&type=script&lang=js"
export * from "./ShippingLabelModal.vue?vue&type=script&lang=js"
import style0 from "./ShippingLabelModal.vue?vue&type=style&index=0&id=f2127b50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2127b50",
  null
  
)

export default component.exports